import { render, staticRenderFns } from "./ChartStaking.vue?vue&type=template&id=68baabd6"
import script from "./ChartStaking.vue?vue&type=script&lang=js"
export * from "./ChartStaking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports